import Box from '@mui/material/Box';
import { QUALITY_TIMELINE, QUALITY_TIMELINE_DISABLED_HATCH } from '../consts';

/**
 * Registers the shared SVG hatch pattern for disabled quality-analysis intervals. Mount once
 * under the stream-quality report (e.g. `ReportResult`) so all timeline charts can use
 * `QUALITY_TIMELINE_DISABLED_HATCH.fill` without duplicating `<defs>` per chart.
 */
export function DisabledHatchPatternDef() {
  const { chartColors } = QUALITY_TIMELINE;

  return (
    <Box
      component="span"
      sx={{
        position: 'absolute',
        width: 0,
        height: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      <svg width={1} height={1}>
        <defs>
          <pattern
            id={QUALITY_TIMELINE_DISABLED_HATCH.patternId}
            width={8}
            height={8}
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(45)"
          >
            <rect width={8} height={8} fill={chartColors.minimapNeutral} />
            <rect x={0} y={0} width={2} height={8} fill={chartColors.grid} />
          </pattern>
        </defs>
      </svg>
    </Box>
  );
}
